module.exports = "../study/imgs/maps/Nagano/S8/Hazard/Slopefailure/Nagano_Slopefailure_MIROC5_RCP85_Now.png";